import { Plus } from 'lucide-react'

type Props = {
  savedCount:      number
  suggestionCount: number
  onAddRecipe:     () => void
}

function getSubline(saved: number, suggested: number): string {
  if (saved === 0 && suggested === 0) return "Save your first recipe, or add what's in the fridge."
  if (saved === 0) return `${suggested} suggestion${suggested === 1 ? '' : 's'} based on what's ripening.`
  if (suggested === 0) return `${saved} recipe${saved === 1 ? '' : 's'} in your collection.`
  return `${saved} you've saved, ${suggested} more worth a look tonight.`
}

export function RecipesMasthead({ savedCount, suggestionCount, onAddRecipe }: Props) {
  return (
    <header className="pb-4 mb-5 border-b border-border-sand">
      <div className="flex items-center justify-between mb-[10px]">
        <div className="text-[10px] tracking-[0.18em] text-ink-muted font-medium uppercase">
          What to cook
        </div>
        <button
          onClick={onAddRecipe}
          className="flex items-center gap-1 rounded-[10px] bg-forest px-3 py-[7px] text-[11px] font-semibold text-forest-ink"
        >
          <Plus className="h-3 w-3" strokeWidth={1.8} />
          Add recipe
        </button>
      </div>

      <h1 className="font-serif text-[30px] font-normal tracking-[-0.015em] text-ink leading-[1.05]">
        <em className="italic">Recipes</em>
      </h1>

      <p className="font-serif text-[14px] italic text-ink-muted mt-1 leading-[1.4]">
        {getSubline(savedCount, suggestionCount)}
      </p>
    </header>
  )
}
